import { Box, Typography } from "@mui/material";
import GenericModal from "components/GenericModal";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { getCommonBaseImageUrl } from "utils/helpers/upload";
import { useAppContextController } from "context/AppContext";

const OnboardingGuideModal = ({ open, setOpen }) => {
  const { company } = useAppContextController();

  const header = (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box sx={{ mt: 2, mb: 1, ml: 2 }}>
        <Typography variant="h5" color="dark">
          Onboarding Documents Upload Guide
        </Typography>
      </Box>
      <IconButton onClick={() => setOpen(false)}>
        <CloseIcon />
      </IconButton>
    </Box>
  );

  const modalBody = (
    <MDBox sx={{ width: "100%" }}>
      <object
        data={`${getCommonBaseImageUrl(company)}/static/i-9%20example%20docs.pdf`}
        type="application/pdf"
        style={{ width: "100%", height: "70vh" }}
      >
        <MDTypography>
          Unable to display PDF file.{" "}
          <a
            href={`${getCommonBaseImageUrl(company)}/static/i-9%20example%20docs.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </a>{" "}
          instead.
        </MDTypography>
      </object>
    </MDBox>
  );

  const modalButtons = (
    <MDButton variant="contained" color="info" onClick={() => setOpen(false)}>
      Close
    </MDButton>
  );

  return (
    <GenericModal
      open={open}
      setOpen={setOpen}
      header={header}
      body={modalBody}
      buttons={modalButtons}
      width="70%"
      overflow="auto"
    />
  );
};

export default OnboardingGuideModal;
